import { useEffect, useState } from "react";

const getReturnValues = (countDown) => {
  // calculate time left
  const days = Math.floor(countDown / (1000 * 60 * 60 * 24));
  const hours = Math.floor(
    (countDown % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
  );
  const minutes = Math.floor((countDown % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((countDown % (1000 * 60)) / 1000);

  return [days, hours, minutes, seconds];
};
const useCountDown = (targetDate) => {
  // 2023,11,25,14,0,0
  const countDownDate = new Date(targetDate).getTime();
  const [countDown, setCountDown] = useState(
    new Date().getTime() - countDownDate
  );

  useEffect(() => {
    const interval = setInterval(() => {
      setCountDown(new Date().getTime() - countDownDate);
    }, 1000);
    return () => clearInterval(interval);
  }, [countDownDate]);

  return getReturnValues(countDown);
}

export default useCountDown;